<!-- Embedded form mode -->
<div *ngIf="simpleCardForm">
  <div class="mb-3 row">
    <label class="col-sm-3 col-form-label">{{simpleCardLabel}}</label>
    <div class="col-sm-9">
      <input type="date" 
             class="form-control" 
             [(ngModel)]="newDateValue"
             (change)="onDateChange($event)">
    </div>
  </div>
</div>

<!-- Modal mode -->
<div *ngIf="!simpleCardForm">
  <div class="modal-header" cdkDrag cdkDragRootElement=".modal-content" cdkDragHandle>
    <h5 class="modal-title">Add Date</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="cancel()"></button>
  </div>

  <div class="modal-body">
    <div class="mb-3">
      <label class="form-label">Choose a date</label>
      <input type="date" 
             class="form-control" 
             [(ngModel)]="newDateValue">
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" 
            class="btn btn-outline-secondary" 
            (click)="clearDate()" 
            *ngIf="newDateValue!=null && canClear">
      Clear
    </button>
    <button type="button" 
            class="btn btn-success" 
            (click)="saveKeyDate()">
      Save
    </button>
  </div>
</div>